import styled from 'styled-components';
import Accordion from '../shared/Accordion';
import { device } from '../../utils/styled-component-mixins';

const TabsWrapperStyled = styled.div`
  .accordion-content {
    background-color: var(--white);
    display: none;

    & > div {
      ${(props) => (props.contentPadding ? `padding: ${props.contentPadding}` : 'padding: 4rem')}
    }
  }

  button:not(.btn) {
    border-style: none;
    border-top: 2px solid var(--grey);
    padding: 2.8rem 1.5rem;
    width: 100%;
    transition: all 0.3s ease-in-out;

    &[aria-expanded='false'] {
      background-color: var(--white);

      &:hover {
        background-color: var(--light-grey-2);
      }
    }

    &[aria-expanded='true'] {
      background-color: var(--slate);
      border: 0;
      color: var(--white);

      .material-icons {
        color: var(--white);
      }
    }

    > div {
      align-items: center;
      display: flex;
      justify-content: space-between;

      > span:first-child {
        text-align: left;
        white-space: normal;
      }

      .material-icons {
        color: var(--charcoal-2);
        font-size: 3rem;
      }
    }
  }

  h3 {
    font-size: 2rem;
    font-weight: 800;
    line-height: 2.4rem;

    @media ${device.desktop} {
      font-size: 2.2rem;
      line-height: 3.2rem;
    }
  }

  .accordion-wysiwyg {
    line-height: 2.4rem;
  }
  .ul-container {
    visibility: hidden;
  }

  .global-locations-button-container {
    padding-bottom: 3rem;
  }

  .locations-button {
    background-color: black;
    border: solid;
    border-color: white;
    color: white;
  }

  .locations-button:hover {
    background-color: white;
    border-color: black;
    color: black;
  }

  .region-button:hover {
    background-color: grey;
    color: white;
  }

  .global-locations-ul {
    align-items: center;

    @media ${device.tablet} {
      /* stylelint-disable-next-line property-no-vendor-prefix */
      -webkit-column-count: 2;
      /* stylelint-disable-next-line property-no-vendor-prefix */
      -moz-column-count: 2;
      column-count: 2;
    }
    @media ${device.desktop} {
      /* stylelint-disable-next-line property-no-vendor-prefix */
      -webkit-column-count: 3;
      /* stylelint-disable-next-line property-no-vendor-prefix */
      -moz-column-count: 3;
      column-count: 3;
    }
  }

  [role='tablist'] {
    display: flex;
    justify-content: center;
    overflow: visible;
    width: 100%;
    flex-direction: column;

    @media ${device.desktop} {
      flex-direction: row;
    }
  }

  [role='tab'] {
    border: 0;
    position: relative;
    margin: 0;
    padding: 1.6rem 4rem;
    overflow: visible;
    font-size: 2.2rem;
    font-weight: 800;
    line-height: 3.2rem;
  }

  [role='tab'][aria-selected='true'] {
    border-radius: 0;
    background-color: var(--slate-transparent);
  }

  [role='tab']:hover,
  [role='tab']:focus,
  [role='tab']:active {
    border-radius: 0;
    color: inherit;
  }

  .tabpanel-wrapper {
    background: linear-gradient(180deg, #e6e9ec 0%, var(--white) 100%);
    padding: 4rem 0 6.7rem 0;
  }

  [role='tabpanel'] {
    position: relative;
    z-index: 2;
  }

  [role='tabpanel'].is-hidden {
    display: none;
  }

  .tab-wysiwyg {
    line-height: 2.4rem;
  }
`;

const GlobalLocationsComponent = (props) => {
  const americas = props.childLocations.filter((obj) => obj.globalLocationRegion === '1');
  const emea = props.childLocations.filter((obj) => obj.globalLocationRegion === '2');
  const asiaPacific = props.childLocations.filter((obj) => obj.globalLocationRegion === '3');

  const allTabs = [
    {
      region: americas,
      pageTitle: 'Americas',
      tabContent: americas,
      testimonials: '',
      services: ''
    },
    {
      region: emea,
      pageTitle: 'EMEA',
      tabContent: emea,
      testimonials: '',
      services: ''
    },
    {
      region: asiaPacific,
      pageTitle: 'Asia Pacific',
      tabContent: asiaPacific,
      testimonials: '',
      services: ''
    }
  ];

  return (
    <TabsWrapperStyled className="container container-padding-default">
      <>
        {allTabs.map((item, index) => (
          <Accordion
            key={`${item.pageTitle}`}
            {...item}
            index={index}
            contentPadding="4.3rem 0 0 0"
            className="accordion-item"
          >
            <>
              <ul className="global-locations-ul">
                {item.tabContent.map((region) => (
                  <li>
                    <a href={region.globalLocationUrl} target="_blank">
                      {region.globalLocationTitle}
                    </a>
                  </li>
                ))}
              </ul>
            </>
          </Accordion>
        ))}
      </>
    </TabsWrapperStyled>
  );
};

export default GlobalLocationsComponent;
